module.exports = function _arrayFromIterator(iter) {
  var list = [];
  var next;
  while (!(next = iter.next()).done) {
    list.push(next.value);
  }
  return list;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ux/hover/node_modules/ramda/src/internal/_arrayFromIterator.js
// module id = 1326
// module chunks = 0